import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Grid,
  DialogActions,
  TextField,
  Typography,
  Box,
} from "@material-ui/core";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { LinehaulFixedDataContext } from "../../Contexts/LinehaulFixedDataContext";
import ButtonApprove from "../ButtonApprove";
import { makeStyles } from "@material-ui/core/styles";
import ButtonDownload from "../ButtonDownload";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    marginBottom: theme.spacing(1),
  },
  flexRowContainer: {
    display: "flex",
  },
  flexRowItem: {
    flexGrow: 1,
    width: "100%",
    // whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const ApproveLinehaul = (props) => {
  const { truckId, itemData, week, day, itemId, ...otherProps } = props;
  const { linehaulFixedModel, routesObj } = useContext(
    LinehaulFixedDataContext
  );

  const { userData } = useContext(UserDataContext);

  const route = routesObj[itemData.routeId];

  const classes = useStyles();

  useEffect(() => {
    console.log(route);
  }, []);

  return (
    <Dialog {...otherProps} fullWidth maxWidth="sm">
      <DialogTitle>Approval Screen</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
          spacing={1}
        >
          {["routeId"].map((col) => (
            <Grid item key={col}>
              <Grid container>
                <Grid item xs={3}>
                  <Typography>
                    {linehaulFixedModel[col].displayName}:
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={itemData[col]}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    {...linehaulFixedModel[col].textFieldProps}
                    children={linehaulFixedModel[col].getChildren(
                      truckId,
                      week
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
          {[
            "adjustment",
            "tripCost",
            "totalCost",
            "driverComments",
            "adminComments",
          ].map((col) => (
            <Grid item key={col}>
              <Grid container>
                <Grid item xs={3}>
                  <Typography>
                    {linehaulFixedModel[col].displayName}:
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={itemData[col]}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    {...linehaulFixedModel[col].textFieldProps}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}

          {/* <Grid item>
            <Grid container>
              <Grid item xs={3}>
                <Typography>Fuel Adjustment Factor:</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  value={Math.round(Number(itemData.totalCost) * 0.068 * 100) / 100}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>

        <Box className={clsx(classes.flexColContainer)}>
          <Box className={clsx(classes.flexColItem, classes.flexRowContainer)}>
            <Box className={clsx(classes.flexRowItem)}></Box>
            <Box className={clsx(classes.flexRowItem)}></Box>
            <Box className={clsx(classes.flexRowItem)}></Box>
          </Box>

          <Box className={clsx(classes.flexColItem, classes.flexRowContainer)}>
            <Typography variant="h6" className={clsx(classes.flexRowItem)}>
              Account Code
            </Typography>
            <Typography variant="h6" className={clsx(classes.flexRowItem)}>
              Cost Centre
            </Typography>
            <Typography variant="h6" className={clsx(classes.flexRowItem)}>
              Percentage
            </Typography>
          </Box>

          {route.percentages.map((percentage, idx) => (
            <Box
              key={idx}
              className={clsx(classes.flexColItem, classes.flexRowContainer)}
            >
              <Typography className={clsx(classes.flexRowItem)}>
                {route.accountCodes[idx]}
              </Typography>
              <Typography className={clsx(classes.flexRowItem)}>
                {route.costCentres[idx]}
              </Typography>
              <Typography className={clsx(classes.flexRowItem)}>{`${
                Number(percentage) * 100
              }%`}</Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <ButtonDownload variant="contained" color="primary" itemId={itemId} />
        <ButtonApprove
          callback={props.onClose}
          variant="contained"
          color="primary"
          controller="linehauls"
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ApproveLinehaul;

ApproveLinehaul.propTypes = {
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
  itemData: PropTypes.object.isRequired,
};
